import React from "react";
import { waveform } from "ldrs";
waveform.register();

export default function LoadingScreen() {
  return (
    <div
      style={{
        background: "#000513",
        width: "100vw",
        height: "100svh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <l-waveform size="35" stroke="3.5" speed="1" color="white"></l-waveform>
    </div>
  );
}
